import React, { useEffect } from 'react';
import { APIS } from "../../../config/apis"
import { Accordion, REQUEST_METHOD, useForm } from '@laramie/ui';
import { standardRequest } from "../../../utils/requests"
import DatePickerCustom from "../DatePickerCustom"
import InputEntidad from "../InputEntidad"
import Modal from "../Modal"

const ESTADOS_FIRMA = {
    0: '',
    650: 'Pendiente',
    651: 'Firmado',
    652: 'Rechazado',
}

const SolicitudFirmaModal = ({ data, onDismiss }) => {

    const [ formValues, , , formSet ] = useForm({
        idEstadoFirma: 0,
        observacion: '',
        idUsuarioSolicitud: 0,
        fechaSolicitud: null,
        idUsuarioFirma: 0,
        fechaFirma: null
    })

    useEffect(() => {
        if (data) {
            formSet({...formValues, ...data })
        }
    }, [data])

    const onClickDownload = async () => {
        try {
            const { file64 } = await standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.FIRMA_DIGITAL}/${data.id}/signed-file`)

            const a = document.createElement("a")
            a.href = "data:application/pdf;base64," + file64
            a.download = "documento.pdf"
            a.click()
        }
        catch { /*excepcion administrada en standardRequest*/ }
    }

    return (
        <Modal
            onEscape={onDismiss}
            show
            title="Estado de firma"
            body={(<>
                <Accordion title="Solicitud" startOpen={true}>
                    <div className='row form-basic'>
                        <div className="col-12 col-md-3">
                            <label htmlFor="idEstadoFirma" className="form-label">Estado</label>
                            <input
                                name="idEstadoFirma"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={ESTADOS_FIRMA[formValues.idEstadoFirma]}
                                disabled
                            />
                        </div>

                        <div className="col-12 col-md-9">
                            <label htmlFor="observacion" className="form-label">Observación</label>
                            <input
                                name="observacion"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={formValues.observacion}
                                disabled
                            />
                        </div>

                        <div className="col-12 col-md-8">
                            <label htmlFor="idUsuarioSolicitud" className="form-label">Usuario/a de solicitud</label>
                            <InputEntidad
                                name="idUsuarioSolicitud"
                                placeholder=""
                                className="form-control"
                                value={formValues.idUsuarioSolicitud}
                                entidad="Usuario"
                                onFormat= {(row) => (row && row.id) ? row.nombreApellido : ''}
                                disabled
                            />
                        </div>

                        <div className="col-12 col-md-4">
                            <label htmlFor="fechaSolicitud" className="form-label">Fecha de solicitud</label>
                            <DatePickerCustom
                                name="periodo"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={formValues.fechaSolicitud}
                                disabled
                            />
                        </div>
                    </div>
                </Accordion>

                <Accordion title="Firma">
                    <div className='row form-basic'>
                        <div className="col-12 col-md-8">
                            <label htmlFor="idUsuarioFirma" className="form-label">Usuario/a de firma</label>
                            <InputEntidad
                                name="idUsuarioFirma"
                                placeholder=""
                                className="form-control"
                                value={formValues.idUsuarioFirma}
                                entidad="Usuario"
                                onFormat= {(row) => (row && row.id) ? row.nombreApellido : ''}
                                disabled
                            />
                        </div>

                        <div className="col-12 col-md-4">
                            <label htmlFor="fechaFirma" className="form-label">Fecha de firma</label>
                            <DatePickerCustom
                                name="periodo"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={formValues.fechaFirma}
                                disabled
                            />
                        </div>
                    </div>
                </Accordion>
            </>)}
            footer={(
                <div className='width-100p disp-b'>
                    <button className="btn back-button" data-dismiss="modal" onClick={onDismiss}>Volver</button>
                    <button className="btn btn-primary" data-dismiss="modal" onClick={onClickDownload}>Descargar archivo</button>
                </div>
            )}
        />
    )
}

export default SolicitudFirmaModal
